module.exports = __webpack_public_path__ + "img/mobile-hp.7e41133f.png";